
/*
Un manager de alertas
*/
(function alertsServiceDefinition() {

    'use strict';

    angular.module('Alerts')
        .provider('alerts', function alertsProvider() {

            this.$get = [
                '$q', '$uibModal', 'config', '$timeout', function alertsFactory($q, $uibModal, config, $timeout) {

                    // uso sweet alert para mostrar las alertas.

                    return {
                        alert: function (title, text, okText, type) {

                            var deferred = $q.defer();

                            $timeout(function () {
                                swal({
                                    title: title,
                                    text: text,
                                    type: type || null,
                                    confirmButtonText: okText
                                }, function () {
                                    deferred.resolve(true);
                                });
                            }, 100);

                            return deferred.promise;
                        },
                        confirm: function (title, text, yesText, noText, type) {

                            var deferred = $q.defer();

                            $timeout(function () {
                                swal({
                                    title: title,
                                    text: text,
                                    type: type || "warning",
                                    confirmButtonText: yesText,
                                    showCancelButton: true,
                                    cancelButtonText: noText
                                }, function (confirmed) {
                                    deferred.resolve(confirmed);
                                });
                            }, 100);

                            return deferred.promise;
                        },
                        /*
                         * Muestra una pantalla con una barra de cargando y el texto especificado.
                         */
                        loading: function (title, text) {

                            var modalInstance = $uibModal.open({
                                templateUrl: config.resourceUrl('/components/alerts/loading.html'),
                                controller: ['$scope', function loadingModalController($scope) {
                                    $scope.loadingTitle = title;
                                    $scope.loadingText = text;
                                }],
                                backdrop: 'static',
                                keyboard: false
                            });

                            return modalInstance;
                        }
                    };

                }
            ];
        });
})();